import React from 'react';

import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DateTimePicker } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import { closeDateTimePickerAction } from 'actions/datePicker';
// import { setEndOfTheDayTime } from 'constants/helper';
import { connect } from 'react-redux';

import { originalSpacingTheme } from 'constants/theme';

function EmptyText(props, x) {
  return <span />;
}

function DateTimePickerComponentWithRedux({
  initialDate,
  onChange,
  error,
  isOpen,
  onOpen,
  onClose,
  onError,
  disablePast = false,
  autoOk = false,
  clearable = true,
  openTo = 'date',
}) {
  // function beforeChange(date) {
  //   if (date) {
  //     setEndOfTheDayTime(date);
  //   }
  //   onChange(date);
  // }
  return (
    // conditionally rendering again and again because of this this bug
    // where update on values prop is not reflected on picker
    // https://github.com/mui-org/material-ui-pickers/issues/1148
    isOpen && (
      <ThemeProvider theme={originalSpacingTheme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DateTimePicker
            clearable={clearable}
            value={initialDate}
            open={isOpen}
            error={Boolean(error)}
            onOpen={onOpen}
            onClose={onClose}
            onError={onError}
            onChange={onChange} // this function gets date as the only param
            disablePast={disablePast}
            TextFieldComponent={EmptyText}
            autoOk={autoOk}
            openTo={openTo}
          />
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    )
  );
}

const mapStateToProps = (state, ownProps) => {
  const { isOpen, onChange, initialDate, autoOk, disablePast, clearable, openTo } = state.dateTimePicker;
  return {
    isOpen,
    onChange,
    initialDate,
    autoOk,
    disablePast,
    clearable,
    openTo,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onClose: () => {
    dispatch(closeDateTimePickerAction());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DateTimePickerComponentWithRedux);
